/**
 * Loading.jsx
 * Created by Stephanie Condrey on 7/25/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgLoading from './SvgLoading';

const Loading = ({ size = 'large' }) => (
    <div className="rec-nested-wrap">
        <div className="rec-grid-12-12">
            <SvgLoading size={size} />
        </div>
    </div>
);

Loading.propTypes = {
    size: PropTypes.string
};

export default Loading;
